import { Component, Input } from '@angular/core';
import { IFrontGroup } from 'src/app/modules/widget/interfaces/front-group';

@Component({
  selector: 'app-status-front',
  templateUrl: './status-front.component.html',
  styleUrls: ['./status-front.component.scss']
})
export class StatusFrontComponent {

  @Input()
  public front: IFrontGroup;

  @Input()
  public set length(length: number) {
    const grow = Math.ceil(12 / length) >= 3 ? Math.ceil(12 / length) : 4;
    this.class = `col-lg-3`;
  }

  public class: string;
  public currentMachine: string;
  public machineValue: string;

}
